var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":'https://widgets.ratemyagent.com/au/Widget/AgentReviews/' + _vm.rateMyAgentId + '?limit=10&isLegacy=false'}})}
var staticRenderFns = []

export { render, staticRenderFns }